import { BlockCheckoutStep } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import { FrontendStepType, PartialWithRequiredType } from "..";

export const blockCheckoutStepType: FrontendStepType<
  PartialWithRequiredType<BlockCheckoutStep>
> = {
  type: "standard",
  valid: (_) => true,
  selectable: (_) => true,
  inspectorFactory: (_props) => ({
    header: {
      title: "Block checkout",
      subtitle:
        "This step blocks the checkout process. Customers reaching this step will not be able to complete their purchase as no shipping options will be available for their physical products.",
    },
    sections: [],
  }),
};
